(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alm-photo-comparison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('alma-photo-comparison')) {
    customElements.define('alma-photo-comparison', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        try {
          this.data = JSON.parse(this.querySelector('[data-comparison]').textContent);
          this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
        } catch { return; }
        if (!this.data.url || !this.data.views?.length) return;
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('.alma-compare__open');
        this.view = this.querySelector('[data-view]');
        this.data.views.forEach((v, i) => {
          const option = document.createElement('option');
          option.value = String(i);
          option.textContent = `${i + 1}. ${this.labels[v] || this.labels.other}`;
          this.view.append(option);
        });
        this.opener.hidden = false;
        this.opener.addEventListener('click', () => {
          this.loadImages();
          this.dialog.showModal();
          this.querySelector('.alma-compare__close').focus();
        });
        this.querySelector('.alma-compare__close').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => this.opener.focus());
        this.dialog.addEventListener('click', e => {
          if (e.target !== this.dialog) return;
          const r = this.dialog.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.dialog.close();
        });
        this.view.addEventListener('change', () => this.updateImages());
      }
      loadImages() {
        if (this.loaded) return;
        this.loaded = true;
        this.querySelectorAll('[data-image-stage]').forEach(frame => {
          const img = document.createElement('img');
          img.src = this.data.url;
          img.width = 2400;
          img.height = this.data.views.length * 800;
          img.decoding = 'async';
          img.style.left = `${-Number(frame.dataset.imageStage) * 100}%`;
          img.addEventListener('error', () => { this.querySelector('.alma-compare__error').hidden = false; });
          frame.append(img);
        });
        this.updateImages();
      }
      updateImages() {
        const row = Number(this.view.value);
        this.querySelectorAll('[data-image-stage]').forEach(frame => {
          const img = frame.querySelector('img');
          if (!img) return;
          img.style.top = `${-row * 100}%`;
          const label = frame.closest('figure').querySelector('strong').textContent.trim();
          img.alt = `${this.querySelector('.alma-compare__product').textContent.trim()} — ${this.view.selectedOptions[0].textContent} — ${label}`;
        });
      }

    });
  }
  } catch(e) { console.error(e); }
})();

})();
